<div class="card mb-3">
  <div class="card-body px-0">
    <div class="px-5">
      <div class="row gx-4 gy-3 mb-4">
        <div class="col-lg-4">
          <h5 class="">{{ 'PANEL.LMS.ASSIGNMENTS.DETAIL.TITLE' | translate }}</h5>
        </div>
      </div>
      <div class="px-2">
        <div class="row gx-4 gy-3 mb-4">
          <div class="col-lg-4">
            <label>{{ 'PANEL.LMS.ASSIGNMENTS.DETAIL.SESSION' | translate }}</label>
          </div>
          <div class="col-lg-8 col-xl-7">
            <span class="fw-bold">{{homework?.lesson}}</span>
          </div>
        </div>
        <div class="row gx-4 gy-3 mb-4">
          <div class="col-lg-4">
            <label>{{ 'PANEL.LMS.ASSIGNMENTS.DETAIL.PRESENTER' | translate }}</label>
          </div>
          <div class="col-lg-8 col-xl-7">
            <div class="d-flex gap-2">
              <div class="chat-avatar">
                <img class="avatar avatar-md me-2"
                  [src]="homework?.instructor?.profileImageUrl ? homework.instructor.profileImageUrl : defaultAvatar" />
              </div>
              <span class="fw-bold">{{homework?.instructor?.fullname}}</span>
            </div>
          </div>
        </div>
        <div class="row gx-4 gy-3 mb-4">
          <div class="col-lg-4">
            <label>{{ 'PANEL.LMS.ASSIGNMENTS.DETAIL.ASSIGNMENT_TITLE' | translate }}</label>
          </div>
          <div class="col-lg-8 col-xl-7">
            <span class="fw-bold">{{homework?.assignmentTitle}}</span>
          </div>
        </div>

        <div class="row gx-4 gy-3 mb-4">
          <div class="col-lg-4">
            <label>{{ 'PANEL.LMS.ASSIGNMENTS.DETAIL.DESCRIPTION' | translate }}</label>
          </div>
          <div class="col-lg-8 col-xl-7">
            <span class="fw-bold" [innerHTML]="homework?.assignmentDescription"></span>
          </div>
        </div>

      </div>

      <div class="line"></div>

      <div class="px-2" *ngFor="let item of homework?.submittedAssignments; let i = index;">
        <div class="row gx-4 gy-3 mb-4">
          <div class="col-lg-4">
            <h5 class="">{{ 'PANEL.LMS.ASSIGNMENTS.DETAIL.SUBMISSION' | translate }} {{i+1}}</h5>
          </div>
        </div>
        <div class="row gx-4 gy-3 mb-4">
          <div class="col-lg-4">
            <label>{{ 'PANEL.LMS.ASSIGNMENTS.DETAIL.SUBMITTED_DATE' | translate }}</label>
          </div>
          <div class="col-lg-8 col-xl-7">
            <span class="fw-bold" *ngIf="item?.submittedDate">
              {{item?.submittedDate | date : 'dd MMM, yyyy'}}</span>
            <span class="fw-bold" *ngIf="!item?.submittedDate">-</span>
          </div>
        </div>
        <div class="row gx-4 gy-3 mb-4" *ngIf="item?.evaluationDate">
          <div class="col-lg-4">
            <label>{{ 'PANEL.LMS.ASSIGNMENTS.DETAIL.EVALUATION_DATE' | translate }}</label>
          </div>
          <div class="col-lg-8 col-xl-7">
            <span class="fw-bold" *ngIf="item?.evaluationDate">
              {{item?.submittedDate | date : 'dd MMM, yyyy'}}</span>
            <span class="fw-bold" *ngIf="!item?.evaluationDate">-</span>
          </div>
        </div>
        <div class="row gx-4 gy-3 mb-4">
          <div class="col-lg-4">
            <label>{{ 'PANEL.LMS.ASSIGNMENTS.DETAIL.STATUS' | translate }}</label>
          </div>
          <div class="col-lg-8 col-xl-7">
            <span *ngIf="item?.status == 10" class="tag tag-blue">{{ 'PANEL.LMS.ASSIGNMENTS.DETAIL.STATUS_NEEDS_IMPROVEMENT' | translate }}</span>
            <span *ngIf="item?.status == 20" class="tag tag-success">{{ 'PANEL.LMS.ASSIGNMENTS.DETAIL.STATUS_APPROVED' | translate }}</span>
            <span *ngIf="item?.status == 0" class="tag tag-pending">{{ 'PANEL.LMS.ASSIGNMENTS.DETAIL.STATUS_PENDING' | translate }}</span>
          </div>
        </div>
        <div class="row gx-4 gy-3 mb-4" *ngIf="item?.score">
          <div class="col-lg-4">
            <label>{{ 'PANEL.LMS.ASSIGNMENTS.DETAIL.SCORE' | translate }}</label>
          </div>
          <div class="col-lg-8 col-xl-7">
            <span class="fw-bold">{{item?.score}}</span>
          </div>
        </div>
        <div class="row gx-4 gy-3 mb-4">
          <div class="col-lg-4">
            <label>{{ 'PANEL.LMS.ASSIGNMENTS.DETAIL.FEEDBACK' | translate }}</label>
          </div>
          <div class="col-lg-8 col-xl-7">
            <span class="fw-bold" [innerHTML]="item?.feedback"></span>
          </div>
        </div>

        <div class="row gx-4 gy-3 mb-4">
          <div class="col-lg-4">
            <label>{{ 'PANEL.LMS.ASSIGNMENTS.DETAIL.ATTACHMENTS' | translate }}</label>
          </div>
          <div class="col-lg-8">
            <div class="d-flex mt-2 flex-wrap">
              <div class="btn btn-dl-attachment" *ngFor="let att of item?.attachments; let j = index">
                <div class="file d-flex gap-2">
                  <i>
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                      <path opacity="0.4"
                        d="M5 30.0007L5 10.0007C5 6.31875 7.98477 3.33398 11.6667 3.33398L21.6667 3.33398C26.11 7.7773 30.5457 12.2283 35 16.6607C35 21.1073 35 25.554 35 30.0007C35 33.6826 32.0152 36.6673 28.3333 36.6673H11.6667C7.98477 36.6673 5 33.6826 5 30.0007Z"
                        fill="#2C997F" />
                      <path
                        d="M21.667 10.0007L21.667 3.33398L35.0003 16.6673L28.3337 16.6673C24.6518 16.6673 21.667 13.6825 21.667 10.0007Z"
                        fill="#2C997F" />
                      <path
                        d="M9.83691 22.7197H12.4785C13.0742 22.7197 13.5283 22.7653 13.8408 22.8564C14.2607 22.9801 14.6204 23.1999 14.9199 23.5156C15.2194 23.8314 15.4473 24.2188 15.6035 24.6777C15.7598 25.1335 15.8379 25.6966 15.8379 26.3672C15.8379 26.9564 15.7646 27.4642 15.6182 27.8906C15.4391 28.4115 15.1836 28.833 14.8516 29.1553C14.6009 29.3994 14.2624 29.5898 13.8359 29.7266C13.5169 29.8275 13.0905 29.8779 12.5566 29.8779H9.83691V22.7197ZM11.2822 23.9307V28.6719H12.3613C12.765 28.6719 13.0563 28.6491 13.2354 28.6035C13.4697 28.5449 13.6634 28.4456 13.8164 28.3057C13.9727 28.1657 14.0996 27.9362 14.1973 27.6172C14.2949 27.2949 14.3438 26.8571 14.3438 26.3037C14.3438 25.7503 14.2949 25.3255 14.1973 25.0293C14.0996 24.7331 13.9629 24.502 13.7871 24.3359C13.6113 24.1699 13.3883 24.0576 13.1182 23.999C12.9163 23.9535 12.5208 23.9307 11.9316 23.9307H11.2822Z"
                        fill="#2C997F" />
                      <path
                        d="M16.7754 26.3428C16.7754 25.6136 16.8844 25.0016 17.1025 24.5068C17.2653 24.1423 17.4867 23.8151 17.7666 23.5254C18.0498 23.2357 18.359 23.0208 18.6943 22.8809C19.1403 22.6921 19.6546 22.5977 20.2373 22.5977C21.292 22.5977 22.1351 22.9248 22.7666 23.5791C23.4014 24.2334 23.7188 25.1432 23.7188 26.3086C23.7188 27.4642 23.4046 28.3691 22.7764 29.0234C22.1481 29.6745 21.3083 30 20.2568 30C19.1924 30 18.346 29.6761 17.7178 29.0283C17.0895 28.3773 16.7754 27.4821 16.7754 26.3428ZM18.2646 26.2939C18.2646 27.1045 18.4518 27.7197 18.8262 28.1396C19.2005 28.5563 19.6758 28.7646 20.252 28.7646C20.8281 28.7646 21.3001 28.5579 21.668 28.1445C22.0391 27.7279 22.2246 27.1045 22.2246 26.2744C22.2246 25.4541 22.0439 24.8421 21.6826 24.4385C21.3245 24.0348 20.8477 23.833 20.252 23.833C19.6562 23.833 19.1761 24.0381 18.8115 24.4482C18.4469 24.8551 18.2646 25.4704 18.2646 26.2939Z"
                        fill="#2C997F" />
                      <path
                        d="M29.4316 27.2461L30.833 27.6904C30.6182 28.4717 30.2601 29.0527 29.7588 29.4336C29.2607 29.8112 28.6276 30 27.8594 30C26.9089 30 26.1276 29.6761 25.5156 29.0283C24.9036 28.3773 24.5977 27.4886 24.5977 26.3623C24.5977 25.1709 24.9053 24.2464 25.5205 23.5889C26.1357 22.9281 26.9447 22.5977 27.9473 22.5977C28.8229 22.5977 29.5342 22.8564 30.0811 23.374C30.4066 23.68 30.6507 24.1195 30.8135 24.6924L29.3828 25.0342C29.2982 24.6631 29.1208 24.3701 28.8506 24.1553C28.5837 23.9404 28.2581 23.833 27.874 23.833C27.3434 23.833 26.9121 24.0234 26.5801 24.4043C26.2513 24.7852 26.0869 25.402 26.0869 26.2549C26.0869 27.1598 26.2497 27.8044 26.5752 28.1885C26.9007 28.5726 27.3239 28.7646 27.8447 28.7646C28.2288 28.7646 28.5592 28.6426 28.8359 28.3984C29.1126 28.1543 29.3112 27.7702 29.4316 27.2461Z"
                        fill="#2C997F" />
                    </svg>
                  </i>
                  <div class="file-details me-2">
                    <div class="file-name">{{att.originalFileName}}</div>
                    <div class="file-size">{{att.sizeInByte / 1024 | number: '1.0-0'}} kb</div>
                  </div>
                </div>

                <a (click)="download(att)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M0.25 15C0.25 17.6234 2.37665 19.75 5 19.75L15 19.75C17.6234 19.75 19.75 17.6234 19.75 15L19.75 11C19.75 8.37665 17.6234 6.25 15 6.25L14.5 6.25C14.0858 6.25 13.75 6.58579 13.75 7C13.75 7.41421 14.0858 7.75 14.5 7.75L15 7.75C16.7949 7.75 18.25 9.20507 18.25 11L18.25 15C18.25 16.7949 16.7949 18.25 15 18.25L5 18.25C3.20507 18.25 1.75 16.7949 1.75 15L1.75 11C1.75 9.20507 3.20507 7.75 5 7.75L5.5 7.75C5.91421 7.75 6.25 7.41421 6.25 7C6.25 6.58579 5.91421 6.25 5.5 6.25L5 6.25C2.37665 6.25 0.25 8.37665 0.25 11L0.25 15ZM6.46967 10.5303C6.17678 10.2374 6.17678 9.76256 6.46967 9.46967C6.76256 9.17678 7.23744 9.17678 7.53033 9.46967L9.25 11.1893L9.25 1C9.25 0.585786 9.58579 0.25 10 0.25C10.4142 0.25 10.75 0.585786 10.75 1L10.75 11.1893L12.4697 9.46967C12.7626 9.17678 13.2374 9.17678 13.5303 9.46967C13.8232 9.76256 13.8232 10.2374 13.5303 10.5303L10.5303 13.5303C10.2374 13.8232 9.76256 13.8232 9.46967 13.5303L6.46967 10.5303Z"
                      fill="#2C997F" />
                  </svg>
                </a>
                <svg *ngIf="item?.status == 0" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                  viewBox="0 0 20 20" fill="none" (click)="deleteAttachment(att,j,$event)" class="ms-2">
                  <path
                    d="M21 6.47998C17.67 6.14998 14.32 5.97998 10.98 5.97998C9 5.97998 7.02 6.07998 5.04 6.27998L3 6.47998"
                    stroke="red" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8.5 5.47L8.72 4.16C8.88 3.21 9 2.5 10.69 2.5H13.31C15 2.5 15.13 3.25 15.28 4.17L15.5 5.47"
                    stroke="red" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M18.85 9.64014L18.2 19.7101C18.09 21.2801 18 22.5001 15.21 22.5001H8.79002C6.00002 22.5001 5.91002 21.2801 5.80002 19.7101L5.15002 9.64014"
                    stroke="red" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M10.33 17H13.66" stroke="red" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M9.5 13H14.5" stroke="red" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div class="line"></div>

      </div>

      <div class="px-2">

        <div class="row gx-4 gy-3 mb-4">
          <div class="col-lg-4">
            <label>{{ 'PANEL.LMS.ASSIGNMENTS.DETAIL.ATTACHMENTS' | translate }}</label>
          </div>
          <div class="col-lg-8 col-xl-7">
            <div class="form-info mb-3">
              <div class="form-group">
                <div class="file-upload">
                  <input type="file" [id]="'teaser'" class="d-none" multiple (change)="onSelectAttachment($event)"
                    formControlName="attachments">
                  <label [for]="'teaser'" class="attachments">
                    <div class="d-flex gap-3">
                      <div class="attachment-icon flex-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M10.8026 4.13674C12.5683 2.37109 15.431 2.37109 17.1966 4.13674C18.9623 5.90239 18.9623 8.76508 17.1966 10.5307L11.8633 15.8641C10.834 16.8933 9.16524 16.8933 8.13597 15.8641C7.10669 14.8348 7.10669 13.166 8.13597 12.1367L13.4693 6.80341C13.7622 6.51051 14.2371 6.51051 14.53 6.80341C14.8229 7.0963 14.8229 7.57117 14.53 7.86407L9.19663 13.1974C8.75314 13.6409 8.75314 14.3599 9.19663 14.8034C9.64011 15.2469 10.3591 15.2469 10.8026 14.8034L16.136 9.47007C17.3158 8.29021 17.3158 6.37727 16.136 5.1974C14.9561 4.01753 13.0432 4.01753 11.8633 5.1974L6.52996 10.5307C4.61371 12.447 4.61371 15.5538 6.52996 17.4701C8.44621 19.3863 11.5531 19.3863 13.4693 17.4701L18.8026 12.1367C19.0955 11.8438 19.5704 11.8438 19.8633 12.1367C20.1562 12.4296 20.1562 12.9045 19.8633 13.1974L14.53 18.5307C12.0279 21.0328 7.97133 21.0328 5.4693 18.5307C2.96727 16.0287 2.96726 11.9721 5.4693 9.47008L10.8026 4.13674Z"
                            fill="white" />
                        </svg>
                      </div>
                      <div>
                        <div class="title">{{ 'PANEL.LMS.ASSIGNMENTS.DETAIL.UPLOAD_TITLE' | translate }}</div>
                        <div class="description">{{ 'PANEL.LMS.ASSIGNMENTS.DETAIL.UPLOAD_DESCRIPTION' | translate }}
                        </div>
                      </div>
                    </div>
                  </label>
                </div>

                <div class="d-flex mt-2 flex-wrap">
                  <button class="btn btn-dl-attachment" *ngFor="let item of myForm?.value?.attachments; let j = index">
                    <div class="file d-flex gap-2">
                      <i>
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                          <path opacity="0.4"
                            d="M5 30.0007L5 10.0007C5 6.31875 7.98477 3.33398 11.6667 3.33398L21.6667 3.33398C26.11 7.7773 30.5457 12.2283 35 16.6607C35 21.1073 35 25.554 35 30.0007C35 33.6826 32.0152 36.6673 28.3333 36.6673H11.6667C7.98477 36.6673 5 33.6826 5 30.0007Z"
                            fill="#2C997F" />
                          <path
                            d="M21.667 10.0007L21.667 3.33398L35.0003 16.6673L28.3337 16.6673C24.6518 16.6673 21.667 13.6825 21.667 10.0007Z"
                            fill="#2C997F" />
                          <path
                            d="M9.83691 22.7197H12.4785C13.0742 22.7197 13.5283 22.7653 13.8408 22.8564C14.2607 22.9801 14.6204 23.1999 14.9199 23.5156C15.2194 23.8314 15.4473 24.2188 15.6035 24.6777C15.7598 25.1335 15.8379 25.6966 15.8379 26.3672C15.8379 26.9564 15.7646 27.4642 15.6182 27.8906C15.4391 28.4115 15.1836 28.833 14.8516 29.1553C14.6009 29.3994 14.2624 29.5898 13.8359 29.7266C13.5169 29.8275 13.0905 29.8779 12.5566 29.8779H9.83691V22.7197ZM11.2822 23.9307V28.6719H12.3613C12.765 28.6719 13.0563 28.6491 13.2354 28.6035C13.4697 28.5449 13.6634 28.4456 13.8164 28.3057C13.9727 28.1657 14.0996 27.9362 14.1973 27.6172C14.2949 27.2949 14.3438 26.8571 14.3438 26.3037C14.3438 25.7503 14.2949 25.3255 14.1973 25.0293C14.0996 24.7331 13.9629 24.502 13.7871 24.3359C13.6113 24.1699 13.3883 24.0576 13.1182 23.999C12.9163 23.9535 12.5208 23.9307 11.9316 23.9307H11.2822Z"
                            fill="#2C997F" />
                          <path
                            d="M16.7754 26.3428C16.7754 25.6136 16.8844 25.0016 17.1025 24.5068C17.2653 24.1423 17.4867 23.8151 17.7666 23.5254C18.0498 23.2357 18.359 23.0208 18.6943 22.8809C19.1403 22.6921 19.6546 22.5977 20.2373 22.5977C21.292 22.5977 22.1351 22.9248 22.7666 23.5791C23.4014 24.2334 23.7188 25.1432 23.7188 26.3086C23.7188 27.4642 23.4046 28.3691 22.7764 29.0234C22.1481 29.6745 21.3083 30 20.2568 30C19.1924 30 18.346 29.6761 17.7178 29.0283C17.0895 28.3773 16.7754 27.4821 16.7754 26.3428ZM18.2646 26.2939C18.2646 27.1045 18.4518 27.7197 18.8262 28.1396C19.2005 28.5563 19.6758 28.7646 20.252 28.7646C20.8281 28.7646 21.3001 28.5579 21.668 28.1445C22.0391 27.7279 22.2246 27.1045 22.2246 26.2744C22.2246 25.4541 22.0439 24.8421 21.6826 24.4385C21.3245 24.0348 20.8477 23.833 20.252 23.833C19.6562 23.833 19.1761 24.0381 18.8115 24.4482C18.4469 24.8551 18.2646 25.4704 18.2646 26.2939Z"
                            fill="#2C997F" />
                          <path
                            d="M29.4316 27.2461L30.833 27.6904C30.6182 28.4717 30.2601 29.0527 29.7588 29.4336C29.2607 29.8112 28.6276 30 27.8594 30C26.9089 30 26.1276 29.6761 25.5156 29.0283C24.9036 28.3773 24.5977 27.4886 24.5977 26.3623C24.5977 25.1709 24.9053 24.2464 25.5205 23.5889C26.1357 22.9281 26.9447 22.5977 27.9473 22.5977C28.8229 22.5977 29.5342 22.8564 30.0811 23.374C30.4066 23.68 30.6507 24.1195 30.8135 24.6924L29.3828 25.0342C29.2982 24.6631 29.1208 24.3701 28.8506 24.1553C28.5837 23.9404 28.2581 23.833 27.874 23.833C27.3434 23.833 26.9121 24.0234 26.5801 24.4043C26.2513 24.7852 26.0869 25.402 26.0869 26.2549C26.0869 27.1598 26.2497 27.8044 26.5752 28.1885C26.9007 28.5726 27.3239 28.7646 27.8447 28.7646C28.2288 28.7646 28.5592 28.6426 28.8359 28.3984C29.1126 28.1543 29.3112 27.7702 29.4316 27.2461Z"
                            fill="#2C997F" />
                        </svg>
                      </i>
                      <div class="file-details me-2">
                        <div class="file-name">{{item.name}}</div>
                        <div class="file-size">{{item.size / 1024| number: '1.0-0'}} kb</div>
                      </div>
                    </div>

                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                      (click)="removeAttachment(j)" class="ms-2">
                      <path
                        d="M21 6.47998C17.67 6.14998 14.32 5.97998 10.98 5.97998C9 5.97998 7.02 6.07998 5.04 6.27998L3 6.47998"
                        stroke="red" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path
                        d="M8.5 5.47L8.72 4.16C8.88 3.21 9 2.5 10.69 2.5H13.31C15 2.5 15.13 3.25 15.28 4.17L15.5 5.47"
                        stroke="red" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path
                        d="M18.85 9.64014L18.2 19.7101C18.09 21.2801 18 22.5001 15.21 22.5001H8.79002C6.00002 22.5001 5.91002 21.2801 5.80002 19.7101L5.15002 9.64014"
                        stroke="red" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M10.33 17H13.66" stroke="red" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M9.5 13H14.5" stroke="red" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </button>
                </div>

              </div>

              <div class="form-group">
                <button type="submit" class="btn btn-primary" [disabled]="loading" [class.loading]="loading"
                  (click)="onSubmit()">{{ 'PANEL.LMS.ASSIGNMENTS.DETAIL.SUBMIT_HOMEWORK' | translate }}
                  <span *ngIf="loading" class="loader"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>



  </div>
  <div class="line"></div>

  <div class="px-5">

  </div>
</div>
<p-confirmDialog></p-confirmDialog>